var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.977,
    height: 19.808,
    viewBox: "0 0 16.977 19.808",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_ionic-ios-refresh",
    "data-name": "Icon ionic-ios-refresh",
    d: "M20.816,13.6a.66.66,0,0,0-.659.6,7.178,7.178,0,1,1-7.34-7.733A.173.173,0,0,1,13,6.65V8.874a.709.709,0,0,0,1.088.6L18.34,6.5a.707.707,0,0,0,0-1.2L14.09,2.361a.709.709,0,0,0-1.088.6V4.978a.174.174,0,0,1-.172.177,8.453,8.453,0,1,0,8.644,9.162.657.657,0,0,0-.659-.712Z",
    transform: "translate(-4.5 -2.251)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReload);
export default __webpack_public_path__ + "static/media/reload.d95cd233e09322a21a53264d4289c0a9.svg";
export { ForwardRef as ReactComponent };